import { CreditCard, PaymentForm } from 'react-square-web-payments-sdk';
import { ApiRequest, ShowLoader } from 'GlobalFunctions';
import { useEffect } from 'react';
import { ProjectConfig } from 'Global';

interface SquareFormProps {
    setPaymentStatus: (data: any) => void;
}

const SquareForm = (props: SquareFormProps) => {
    console.log('=== SquareForm COMPONENT RENDERING ===');
    const { setPaymentStatus } = props;

    // Hide the subscription form's add-btn when Square is used
    // Square has its own Pay button that handles validation
    useEffect(() => {
        console.log('=== SquareForm useEffect RUNNING ===');
        
        // Find and hide the add-btn inside the subscription form
        const subscriptionForm = document.querySelector('[pc="subscription-form"]');
        const addButton = subscriptionForm?.querySelector('[pc="add-btn"]') as HTMLElement;
        
        console.log('Subscription form found:', subscriptionForm);
        console.log('Add button found inside subscription form:', addButton);
        
        if (addButton) {
            // Hide the original add-btn since Square has its own button
            addButton.style.display = 'none';
            console.log('Hidden add-btn, Square will use its own Pay button');
        }
        
        // Cleanup: restore button visibility on unmount
        return () => {
            if (addButton) {
                addButton.style.display = '';
            }
        };
    }, []);

    return (
        <PaymentForm 
            applicationId={ProjectConfig.SQUARE_CLIENT_ID}
            cardTokenizeResponseReceived={async (token, verifiedBuyer) => {
                console.log('=== Square cardTokenizeResponseReceived ===');
                console.log('Token received:', token);
                
                // Validate client fields before processing payment
                const subscriptionData = localStorage.getItem('subscription');
                if (!subscriptionData) {
                    setPaymentStatus({ status: 'error', message: 'No subscription data found' });
                    return;
                }
                
                const data = JSON.parse(subscriptionData);
                
                // Validate required client fields
                const requiredFields = ['name', 'lastname', 'country', 'postal', 'email', 'phone'];
                const missingFields = requiredFields.filter(field => !data.client?.[field]);
                
                if (missingFields.length > 0) {
                    setPaymentStatus({ 
                        status: 'error', 
                        message: `Required fields missing: ${missingFields.join(', ')}` 
                    });
                    return;
                }
                
                ShowLoader(true);

                await ApiRequest({
                    url: "/payments/subscriptionCheckout",
                    method: "post",
                    body: {
                        subscription_data: data,
                        sourceId: token.token,
                        payment_method: 'square'
                    },
                    setResponse: (response: any) => {
                        console.log('Square checkout response:', response);
                        setPaymentStatus(response);
                    }
                });
                ShowLoader(false);
            }}
            locationId='LBB7R4DKKTWBG'
        >
            <CreditCard 
                includeInputLabels
                buttonProps={{
                    css: {
                        backgroundColor: '#006aff',
                        color: 'white',
                        marginTop: '10px',
                        width: '100%',
                        padding: '12px',
                        borderRadius: '5px',
                        fontSize: '16px',
                        fontWeight: 'bold',
                    },
                }}
            />
        </PaymentForm>
    );
};

export default SquareForm;
